import { render } from "./targetAgeInput.vue?vue&type=template&id=a3154638"
import script from "./targetAgeInput.vue?vue&type=script&lang=js"
export * from "./targetAgeInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__